<template>
  <div class="home" ref="screenDom">
    <div id="canvasContainer" class="canvas-container"></div>
    <div v-for="(item, index) in tagsInfo" :key="'tag-' + index" :id="'tag-' + index">
      <div class="elementContent">
        <h3>{{ item.roomName }}</h3>
        <p>温度：{{ item.showaveTtValue === null ? '--' : item.showaveTtValue }}°C</p>
      </div>
    </div>
    <BigScreen></BigScreen>
    <div class="button-group">
      <template v-if="roam">
        <el-button type="danger" @click="roam3D" plain>结束漫游</el-button>
        <el-button v-if="stop" type="primary" @click="changeClick" round>播放</el-button>
        <el-button v-else type="danger" @click="changeClick" round>暂停</el-button>
      </template>
      <el-button v-else type="primary" @click="roam3D" plain>库区漫游</el-button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";
import ThreePlus from "../three/index";
// import eventHub from "@/utils/eventHub";
// import modifyCityMaterial from "../three/modify/modifyCityMaterial";
import BigScreen from "../components/BigScreen.vue";
import { getRoomShowave } from "@/api/common";
import { useRouter } from "vue-router";
const { currentRoute } = useRouter();
const router = currentRoute.value
import gsap from "gsap";
// let progress = ref(0);

let screenDom = ref(null);
let tagsInfo = ref([]);
let tags = [];
let wallGroup;
let floor1Group;
const resizeFn = () => {
  window.location.reload();
  // console.log(screenDom);
  // let scale = window.innerWidth / 1920;
  // screenDom.value.style.transform = `scale(${scale})`;
};
let roam = ref(false);
let stop = ref(false);
let timer;
const changeClick = () => {
  stop.value = !stop.value;
  threePlus.controlTween(stop.value);
}
const hideWall = () => {
  gsap.to(wallGroup.position, {
    y: 200,
    delay: 3,
    duration: 3,
    onComplete: () => {
      if (tags.length < 1) {
        tagsInfo.value.forEach((item, index) => {
          const object3d = floor1Group.getObjectByName(item.roomName);
          const tag = threePlus.createTag(object3d, 'tag-' + index);
          tags.push(tag);
        })
      } else {
        tags.forEach(item => {
          item.visible = true;
        })
      }
      // 设置自动旋转;
      threePlus.control.autoRotate = true;
    }
  });
}
const roam3D = () => {
  roam.value = !roam.value;
  stop.value = false;
  if (roam.value) {
    threePlus.roam3D();
  } else {
    threePlus.stopRoam3D();
    threePlus.control.autoRotate = true;
    tags.forEach(item => {
      item.visible = false;
    })
    gsap.to(wallGroup.position, {
      y: 36.74512481689453,
      delay: 2,
      duration: 2,
      onComplete: () => {
        hideWall();
      }
    });
  }
}
const getData = () => {
  getRoomShowave(router.query.projectId).then(res => {
    if (res.success) {
      tagsInfo.value = res.data;
      timer = setTimeout(() => {
        getData();
      }, 10 * 1000)
    }
  })
}
onBeforeUnmount(() => {
  clearTimeout(timer)
})
onMounted(() => {
  // resizeFn();
  // window.addEventListener("resize", resizeFn);
  // const container = document.querySelector(".canvas-container");
  let threePlus = new ThreePlus("#canvasContainer");
  window.threePlus = threePlus;
  threePlus.camera.position.set(0, 180, 540);
  // let bgPromise = threePlus.setBgExr("./assets/textures/hilly_terrain_01_4k.exr");
  threePlus.setLight();
  // threePlus.setSpotLight();
  getData();
  // threePlus.addCloudsPlus();
  // threePlus.addClouds();
  // threePlus.addLawn(new THREE.Vector2(10000, 10000));
  // threePlus.addReflectorPlane(new THREE.Vector2(1000,1000))
  // threePlus.addMirrorPlane(new THREE.Vector2(1000,1000));
  // let bgPromise = threePlus.setBgJpg("./assets/textures/sky/sky20.jpg")
  threePlus.setBgArr(['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg', '6.jpg'])
  // threePlus.addOcean();

  // 创建视频纹理
  // let video = document.createElement("video");
  // video.src = "./textures/video/sucai02.mp4";
  // video.autoplay = true;
  // video.loop = true;
  // video.muted = true;
  // video.play();
  // let videoTexture = new THREE.VideoTexture(video);

  threePlus.gltfLoader("./model/k6.glb").then((gltf) => {
    wallGroup = gltf.scene.getObjectByName("屋顶");
    floor1Group = gltf.scene;
    // let dimian = gltf.scene.getObjectByName("地面");
    // dimian.castShadow = true;
    // dimian.receiveShadow = true; // 接收阴影
    // dimian.material.shadowSide = THREE.BackSide;
    // let qiang = gltf.scene.getObjectByName("_001");
    // qiang.castShadow = true; // 投射阴影
    // qiang.receiveShadow = true;
    // qiang.material.shadowSide = THREE.BackSide;
    hideWall();
    // let vetroMaterial = null;
    // gltf.scene.traverse((child) => {
    // console.log(child.name)
    // if (child.isMesh) {
    //   child.castShadow = true;
    //   child.receiveShadow = true;
    //   child.material.shadowSide = THREE.BackSide;
    // }
    // if (child.isMesh && child.name == "Plane") {
    //   child.visible = false;
    // }
    // if (
    //   child.isMesh &&
    //   child.material.name == "Vetro" &&
    //   vetroMaterial == null
    // ) {
    //   vetroMaterial = child.material;
    // }
    // });
    // bgPromise.then((texture) => {
    //   threePlus.addSphereSky(
    //     () => {
    //       // vetroMaterial.emissive = new THREE.Color(0x000000);
    //       // threePlus.unrealBloomPass.enabled = false;
    //     },
    //     () => {
    //       // console.log("夜晚");
    //       // vetroMaterial.emissive = new THREE.Color(0x99cc99);
    //       // vetroMaterial.emissiveMap = videoTexture;
    //       // vetroMaterial.emissiveIntensity = 1;
    //       // threePlus.unrealBloomPass.enabled = true;
    //     }
    //   );
    // });

    threePlus.scene.add(gltf.scene);
  });
  // THREE.DefaultLoadingManager.onProgress = function (item, loaded, total) {
  //   console.log(item, loaded, total);
  //   progress.value = new Number((loaded / total) * 100).toFixed(2);
  // };
});
</script>

<style>
.home {
  width: 100%;
  /* width: 1920px; */
  /* height: 1080px; */
  height: 100vh;
  transform-origin: 0 0;
}

.canvas-container {
  width: 100%;
  height: 100%;
}

.button-group {
  position: absolute;
  top: 64px;
  right: 480px;
}
</style>
